export default "__VITE_ASSET__BSNj00dx__"